<template>
    <div class="main">
        <div style="margin-bottom: 30px;"></div>
        <div class="container_1">
            <div class="row">
                <div class="min_bg">
                    <div class="panel">
                        <div class="header-1">
                            <h2><a>个人中心</a></h2>
                        </div>
                        <div class="part-title">
                            <div class="part-title-line"></div>
                            <div class="part-tittle-text">个人信息</div>
                        </div>
                        <div class="info-container">
                            <div class="item22 shadow">
                                <div class="left-text pr16">用户名：</div>
                                <div class="middle-text"><span>{{user.name}}</span></div>
                            </div>
                            <div class="item22">
                                <div class="left-text">账户密码：</div>
                                <div class="middle-text">
                                    <span>******</span>
                                </div>
                                <div class="right-text"><a class="pl32" @click="updatePwd">修改</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                title="修改密码"
                :visible.sync="dialogVisible"
                width="30%">
            <el-form ref="form" :model="model" label-width="80px" :rules="rules">
                <el-form-item label="旧密码" prop="oldPwd">
                    <el-input v-model="model.oldPwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pwd">
                    <el-input v-model="model.pwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="pwd2">
                    <el-input v-model="model.pwd2" type="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import userService from '../service/user'

    export default {
        name: 'UserProfile',
        data() {
            const checkPwd2 = (rule, value, callback) => {
                if (value && this.model.pwd && value !== this.model.pwd) {
                    callback(new Error('密码不一致'));
                } else {
                    callback();
                }
            }
            return {
                dialogVisible: false,
                model: {},
                rules: {
                    oldPwd: [
                        {required: true, message: '请输入旧密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd2: [
                        {required: true, message: '请输入确认密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkPwd2, trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            ...mapState(['user'])
        },
        methods: {
            updatePwd() {
                this.model = {}
                this.dialogVisible = true
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    userService.updatePwd({
                        data: {oldPwd: this.model.oldPwd, pwd: this.model.pwd}
                    }).then(() => {
                        this.dialogVisible = false
                        this.$message({
                            type: 'success',
                            message: '修改密码成功!'
                        })
                    }).catch((error) => {
                        if (error.response && error.response.status === 409) {
                            this.$message({
                                type: 'error',
                                message: '修改密码失败，旧密码错误!'
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: '修改密码失败!'
                            })
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
